export function normalizeDateOnly(date) {
  if (!date) return null;
  // Handle both string dates and Date objects
  const d = typeof date === "string" ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return null;
  // Normalize to midnight UTC for comparison
  return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
}

export function isDateMatch(dateText, targetDate) {
  if (!dateText) return false;
  const target = normalizeDateOnly(targetDate);
  const date = normalizeDateOnly(dateText);
  if (!target || !date) return false;
  return target.getTime() === date.getTime();
}

export function isDateWithinWindow(startText, endText, targetDate) {
  if (!startText || !endText) return false;
  const target = normalizeDateOnly(targetDate);
  const start = normalizeDateOnly(startText);
  const end = normalizeDateOnly(endText);
  if (!target || !start || !end) return false;
  return target.getTime() >= start.getTime() && target.getTime() <= end.getTime();
}

export function isDateInWeek(dateText, weekStartDate) {
  if (!dateText) return false;
  const date = normalizeDateOnly(dateText);
  const weekStart = normalizeDateOnly(weekStartDate);
  if (!date || !weekStart) return false;
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekEnd.getDate() + 6);
  const weekEndNormalized = normalizeDateOnly(weekEnd);
  return date.getTime() >= weekStart.getTime() && date.getTime() <= weekEndNormalized.getTime();
}

export function isDateWindowInWeek(startText, endText, weekStartDate) {
  if (!startText || !endText) return false;
  const weekStart = normalizeDateOnly(weekStartDate);
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekEnd.getDate() + 6);
  const weekEndNormalized = normalizeDateOnly(weekEnd);
  const start = normalizeDateOnly(startText);
  const end = normalizeDateOnly(endText);
  if (!weekStart || !weekEndNormalized || !start || !end) return false;
  // Check if the date window overlaps with the week
  return (start.getTime() <= weekEndNormalized.getTime() && end.getTime() >= weekStart.getTime());
}

export function getWeekStart(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1); // Adjust to Monday
  return new Date(d.setDate(diff));
}

export function formatDate(date) {
  return date.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
}

export function formatWeekRange(weekStart) {
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekEnd.getDate() + 6);
  return `${weekStart.toLocaleDateString("en-US", { month: "short", day: "numeric" })} - ${weekEnd.toLocaleDateString("en-US", { month: "short", day: "numeric" })}`;
}

export function getDayOfWeek(date) {
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  return days[date.getDay()];
}

export function getDayAbbreviation(date) {
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  return days[date.getDay()];
}

